import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CertifiedChart"] */ "/app/src/components/CertifiedChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KpiStrip"] */ "/app/src/components/KpiStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageSpeedOverview"] */ "/app/src/components/PageSpeed/PageSpeedOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PageSpeed/SiteMetadataOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustSecurityOverview"] */ "/app/src/components/PageSpeed/TrustSecurityOverview.tsx");
